import { useMemo } from "react";
import { IS_SERVER } from "@/helpers/CompileHelper";
import { useStateContext } from "@/components/state";
import usePagesAbstract from "@/scenes/_shared/stages/pages";
import Final from "@/scenes/finn/stage/final";
import S01 from "@/scenes/finn/stage/01";
import S02 from "@/scenes/finn/stage/02";
import S03 from "@/scenes/finn/stage/03";
import S04 from "@/scenes/finn/stage/04";
import S05 from "@/scenes/finn/stage/05";
import S06 from "@/scenes/finn/stage/06";
import S07 from "@/scenes/finn/stage/07";
import S08 from "@/scenes/finn/stage/08";
import S09 from "@/scenes/finn/stage/09";
import S10 from "@/scenes/finn/stage/10";
import S11 from "@/scenes/finn/stage/11";
import S12 from "@/scenes/finn/stage/12";
import S13 from "@/scenes/finn/stage/13";
import S14 from "@/scenes/finn/stage/14";
import S15 from "@/scenes/finn/stage/15";
import S16 from "@/scenes/finn/stage/16";

const usePages = (props) => {
    const context = useStateContext();
    const { state } = context;

    const createPageFlow = () => {
        const list = [];

        list.push(S01); // Start page
        if (state?.client?.type !== "SELLER") isBuyer(state, list);
        if (state?.client?.type === "SELLER") isSeller(state, list);

        return list;
    }

    const pages = useMemo(() => {
        if (IS_SERVER) return [];
        if (!context || !state) return [];
        return createPageFlow();
    }, [
        state?.client?.type,
        state?.sale?.sold?.detail,
        state?.sale?.acquired_never,
    ])
    const abstract = usePagesAbstract({ pages, ...props });

    return {
        pages,
        ...abstract,
    }
}

export default usePages;

const isBuyer = (state, list) => {
    list.push(S02); // About the buyer
    list.push(S09); // About the timeframe

    if (!state?.sale?.acquired_never) {
        list.push(S06); // About the car
        list.push(S07); // Information about the car before purchase
        list.push(S08); // What is the issue?
        list.push(S10); // When did you discover the issue?
        list.push(S11); // Has the vehicle been inspected since?
        list.push(S12); // Any price concessions/corrections?
        list.push(S14); // What do you expect from the seller?
        list.push(S13); // Have you made a complaint to the seller?
        list.push(S15); // Is there anything else we should know?
    }

    list.push(Final); //
}

const isSeller = (state, list) => {
    list.push(S03); // About the seller

    if (["WAS_NOT_SOLD"].includes(state?.sale?.sold?.detail)) {
        list.push(Final);
        return;
    }

    list.push(S04); // About the sale
    list.push(S05); // About the claim
    list.push(S16); // Documentation and final words
    list.push(Final); //
}
